import { useEffect, useState } from "react";
import PurchaseTable from "../../components/purchase/PurchaseTable";
import useApi from "../../api";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import { Paginator, StatusBar } from "../../components/common";
import PurchaseCreate from "../../components/purchase/create/PurchaseCreate";
import { handleRetriveError } from "../../utils";

function PurchaseOrder() {
  const api = useApi()
  const [purchaseOrders, setPurchaseOrders] = useState<any>()
  const [isOpenPurchaseCreate, setIsOpenPurchaseCreate] = useState<any>(false)

  const getPurchaseOrders = () => {
    api.getPurchaseOrders().then((response:any)=>{
      setPurchaseOrders(response)
    }, handleRetriveError)
  };

  useEffect(()=>{
    getPurchaseOrders()
  },[])

  return (
    <PageBodyWrapper>
      <StatusBar
        statusList={[]}
        buttonLabel="Create Purchase"
        onButtonClick={()=>setIsOpenPurchaseCreate(!isOpenPurchaseCreate)}
      />
      
      <PurchaseTable data={purchaseOrders} refresh={getPurchaseOrders}/>
      <Paginator data={purchaseOrders}/>

      <PurchaseCreate isOpen={isOpenPurchaseCreate} onClose={()=>setIsOpenPurchaseCreate(!isOpenPurchaseCreate)} refresh={getPurchaseOrders}/>
    </PageBodyWrapper>
  );
}

export default PurchaseOrder;
